var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_mark",
    "data-name": "check mark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.917,
    height: 29.917,
    viewBox: "0 0 29.917 29.917",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2737",
    "data-name": "Rectangle 2737",
    width: 29.917,
    height: 29.917,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3959",
    "data-name": "Group 3959",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3958",
    "data-name": "Group 3958",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7298",
    "data-name": "Path 7298",
    d: "M29.917,14.958A14.958,14.958,0,1,1,14.958,0,14.958,14.958,0,0,1,29.917,14.958",
    fill: "#6b8ba7"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7114",
    "data-name": "Path 7114",
    d: "M754.324,841.511l-5.983-5.983,2.215-2.215,3.769,3.768,9.533-9.533,2.215,2.215Z",
    transform: "translate(-741.574 -819.571)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/checkMark.5280b5d29cd8ccf74325c0f3e70208fa.svg";
export { ForwardRef as ReactComponent };